import { create } from "zustand";
import { persist } from "zustand/middleware";

import { localStorageKeys } from "../config";
import type { ProjectID, ViewLinkID } from "../types";

export type VisitedViewLinksByProject = Record<ProjectID, ViewLinkID[]>;

interface VisitedViewLinksState {
  visitedByProject: VisitedViewLinksByProject;
  addVisitedViewLink: (projectId: ProjectID, viewLinkId: ViewLinkID) => void;
}

const initialState: VisitedViewLinksByProject = {};

export const useVisitedViewLinksStore = create<VisitedViewLinksState>()(
  persist(
    (set) => ({
      visitedByProject: initialState,
      addVisitedViewLink: (projectId: ProjectID, viewLinkId: ViewLinkID) =>
        set((state) => {
          const existingViewLinks = state.visitedByProject[projectId] ?? [];
          if (existingViewLinks.includes(viewLinkId)) {
            return state;
          }
          return {
            visitedByProject: {
              ...state.visitedByProject,
              [projectId]: [...existingViewLinks, viewLinkId],
            },
          };
        }),
    }),
    {
      name: localStorageKeys.visitedViewLinks,
    }
  )
);

export const useVisitedViewLinks = (projectId: ProjectID) =>
  useVisitedViewLinksStore((state) => state.visitedByProject[projectId] ?? []);
